import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Breadcrumb from '../Components/Common/breadcrumb/Breadcrumb';
import { useSelector } from 'react-redux';

const AdminProtected = (props) => {
    const location = useLocation();
    const vendorId = useSelector((state) => state?.VendorSideDashboard?.result?.vendorId);
    const navigate = useNavigate();

    const admin_breadcrumbItems = {
        '/team-list': [
            { text: 'Vendor Management', url: '/admin/vendor' },
            { text: `View Vendor Details`, url: `/admin/vendor/view?vendorId=${vendorId}` },
            { text: 'Team Members', url: '/' },
        ],
        '/view': [
            { text: 'Vendor Management', url: () => navigate('/admin/vendor', { state: { active: location?.state?.active ?? 'ALL' } }) },
            { text: `View Vendor Details`, url: `/admin/vendor/view?vendorId=${vendorId}` },
        ],
        '/posted_jobs': [
            { text: 'Vendor Management', url: '/admin/vendor' },
            { text: `View Vendor Details`, url: `/admin/vendor/view?vendorId=${vendorId}` },
            { text: 'Job Management', url: '/' },
        ],
        '/viewJob': [
            { text: 'Job Management', url: () => navigate('/admin/job') },
            { text: 'Vendor Jobs', url: '/admin/job/vendor_jobs' },
            { text: 'Job Details', url: '/' },
        ],
        '/vendor_jobs': [
            { text: 'Job Management', url: () => navigate('/admin/job') },
            { text: 'Vendor Jobs', url: '/' },
        ],
        // '/job-details' : [
        //     { text: 'Vendor Management', url: '/admin/vendor' },
        //     { text: `View Vendor Details`, url: `/admin/vendor/view?vendorId=${vendorId}` },
        //     { text: 'Job Management', url: '/admin/posted_jobs' },
        //     { text: 'job details' , url : '/'}
        // ],
        '/viewCandidate': [
            { text: 'Candidate Management', url: '/admin/candidate' },
            { text: 'Candidate Details', url: '/' },
        ],
        '/interviews_info': [
            { text: 'Interview Management', url: () => navigate(-1) },
            { text: 'Interview Details', url: '/' }
        ],
    };

    const { Component } = props;

    const extractBasePath = (path) => {
        // if(path.includes('admin')){
        //     const parts = path.split('/').slice(-1)[0].split('?')[0];
        //     return `/${parts}`;
        // }

        const dynamicPaths = Object.keys(admin_breadcrumbItems).filter(path => path.includes('/:id'));

        for (let dynamicPath of dynamicPaths) {
            const regex = new RegExp(dynamicPath.replace('/:id', '/\\d+'));
            if (regex.test(path)) {
                return dynamicPath;
            }
        }

        const parts = path.split('/');
        // console.log("part ", parts);
        if (admin_breadcrumbItems[`/${parts[parts.length - 1]}`]) {
            return `/${parts[parts.length - 1]}`;
        }

        return null;

    };

    const currentPath = location.pathname;
    const basePath = extractBasePath(currentPath);
    console.log("basePaathh : ", basePath);
    return (
        <>
            {location.pathname.includes('admin') && (
                <Breadcrumb items={admin_breadcrumbItems[basePath] || []} />
            )}
            <div style={{ paddingTop: location.pathname.includes('/admin/purchase-order/details') ? '20px' : '10px' }}>
                <Component />
            </div>
        </>
    );
}

export default AdminProtected;
